import React from "react";
import { useSelector, useDispatch } from "react-redux";
import actionTypes from "../redux/action.types";

const LANGS = [
  { code: "es-es", label: "ES", title: "Español" },
  { code: "en-us", label: "EN", title: "English" },
];

export default function LanguageSelector({ className = "" }) {
  const dispatch = useDispatch();
  const defLang = useSelector((state) => state.Login.defLang);

  const toggle = () => {
    const next = defLang === "es-es" ? "en-us" : "es-es";
    dispatch({ type: actionTypes.CHANGE_LANGUAGE, payload: next });
  };

  const current = LANGS.find((l) => l.code === defLang) || LANGS[0];

  return (
    <button
      type="button"
      onClick={toggle}
      className={`xflow-lang-toggle ${className}`.trim()}
      title={current.code === "es-es" ? "Switch to English" : "Cambiar a Español"}
      aria-label={current.title}
    >
      {current.label}
    </button>
  );
}
